import React from 'react';
import { useUpdateGroup } from 'src/components/enterprise/EnterpriseGroups/AddEmployeeToGroupModal.utils';
import { ManageEnterpriseEmployeeModal } from 'src/components/ManageEnterpriseEmployeeModal/ManageEnterpriseEmployeeModal';

export interface AddEmployeeToGroupModalProps {
  onClose: () => void;
  onSuccess: () => void;
  corpId: string;
  groupId: string;
}

export function AddEmployeeToGroupModal({
  corpId,
  groupId,
  onClose,
  onSuccess,
}: AddEmployeeToGroupModalProps): JSX.Element {
  const { updateGroup } = useUpdateGroup({
    corpId,
    groupId,
    onSuccess,
  });
  return (
    <ManageEnterpriseEmployeeModal
      corpId={corpId}
      closeModal={onClose}
      onSuccess={updateGroup}
    />
  );
}
